<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <h6>
                <span>Baisse totale</span>
                <p class="value">{{ price_change | number:'1.0-0'  }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Évolution du prix de l'annonce</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/baissedeprix.PNG" class="img-fluid" />

        <div class="card-text row" *ngIf="!preview">
            <div *ngIf="!loading" echarts [options]="options" [merge]="data" class="chart"></div>
        </div>
    </div>
</div>
